"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var style = _interopRequireWildcard(require("./Error.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Error = props => {
  const {
    retry
  } = props;
  const deviceType = (0, _uiKit.useDeviceType)();
  const isMobile = deviceType === 'phone';
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "Error",
    "data-name": "Error",
    className: style['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['header']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A")), /*#__PURE__*/React.createElement("div", {
    className: style['text']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 ", /*#__PURE__*/React.createElement("br", null), "\u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C")), /*#__PURE__*/React.createElement("div", {
    className: style['action']
  }, retry && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_uiKit.Button, {
    fullWidth: isMobile,
    size: isMobile ? 'M' : 'XS',
    onClick: retry
  }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C")))));
};
exports.Error = Error;